import { GetCookies, CookieResponse, SetCookies } from "../Definitions/MessageTypes";

export class CookieHost {
	private readonly cookieCommPort: MessagePort;

	constructor(cookieMessagePort: MessagePort) {
		if (!cookieMessagePort) {
			throw new ReferenceError();
		}
		this.cookieCommPort = cookieMessagePort;
		cookieMessagePort.onmessage = (event: MessageEvent) => {
			this.OnMessage(event);
		};
	}

	private OnMessage(event: MessageEvent): void {
		if (event.data?.type === SetCookies) {
			const cookieString = event.data?.cookieString;
			if (typeof cookieString !== "string") {
				console.error("Argument to SetCookie request is not a string");
				return;
			}
			document.cookie = cookieString;
		} else if (event.data?.type === GetCookies) {
			const cookieString = document.cookie;
			const cookieResponsePort = event.ports[0];
			cookieResponsePort.postMessage({ type: CookieResponse, cookieString });
		} else {
			console.error("Unknown message in cookieChannel");
		}
	}
}
